import React, { useEffect } from 'react'
import Layout from '../components/Layout'
import CountryBanner from '../components/Beneficiary/CountryBanner'
import AreasMetrics from '../components/Beneficiary/AreasMetrics'
import CountryBudget from '../components/Beneficiary/CountryBudget';



function Beneficiary({country,id}) {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [country]); 

  return (
    <Layout>
        <CountryBanner country={country} id={id} />
        <AreasMetrics country={country} id={id} />
        <CountryBudget country={country} id={id} />
    </Layout>
  )
}

export default Beneficiary